'use client';

import { useEffect, useRef, useState } from 'react';

interface Star {
  top: number;
  left: number;
  size: number;
  background: string;
  speed: number;
}

const colors = [
  '#FFFFFF',
  '#7DF9FF',
  '#1E90FF',
  'radial-gradient(circle, #00FFFF, #0066FF)',
  'radial-gradient(circle, #7DF9FF, #1E90FF)',
];

const ShootingStarBackground = () => {
  const [stars, setStars] = useState<Star[]>([]);
  const starRefs = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    const newStars: Star[] = Array.from({ length: 150 }).map(() => ({
      top: Math.random() * 100,
      left: Math.random() * 100,
      size: Math.random() * 2 + 1,
      background: colors[Math.floor(Math.random() * colors.length)],
      speed: 0.1 + Math.random() * 0.3,
    }));
    setStars(newStars);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      starRefs.current.forEach((el, idx) => {
        if (!el) return;
        const { speed } = stars[idx];
        el.style.transform = `translateY(${scrollY * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [stars]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        zIndex: -1,
        pointerEvents: 'none',
      }}
    >
      {stars.map((star, index) => (
        <div
          key={index}
          ref={(el) => {
            if (el) starRefs.current[index] = el;
          }}
          style={{
            position: 'absolute',
            top: `${star.top}%`,
            left: `${star.left}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            borderRadius: '50%',
            background: star.background,
            boxShadow: `0 0 6px ${
              star.background.startsWith('radial') ? '#7DF9FF' : star.background
            }`,
          }}
        />
      ))}
    </div>
  );
};

export default ShootingStarBackground;
